<ng-container [ngSwitch]="loading < 1">
    <h3 class="dialog__heading dialog__header--targets" mat-dialog-title>
        Enter Targets
    </h3>
    <form #form="ngForm" (validSubmit)="submit()">
        <div
            mat-dialog-content
            *ngSwitchCase="true"
            class="performance-targets"
        >
            <ul class="list-horizontal performance-targets__actions">
                <li class="list--item__right">
                    <a (click)="monthClick(-1)">
                        <fa-icon icon="chevron-left"></fa-icon>
                    </a>
                    <span class="performance-targets__date ng-binding">{{
                        currentDate.format('MMM, YYYY')
                    }}</span>
                    <a (click)="monthClick(1)">
                        <fa-icon icon="chevron-right"></fa-icon>
                    </a>
                </li>
            </ul>

            <div class="performance-targets__header row">
                <div class="col-2"></div>
                <div class="col-2">Min revenue before bonus</div>
                <div class="col-3">Good Target</div>
                <div class="col-3">Great Target</div>
            </div>

            <div
                class="performance-target row"
                *ngFor="let performanceTarget of performanceTargets"
            >
                <label class="input-label col-2 performance-targets__row_column">
                    <location-label
                        [locationId]="performanceTarget.location_id"
                    ></location-label>
                </label>
                <div class="col-2">
                    <input
                        class="input--small"
                        type="number"
                        required
                        [name]="'target-' + performanceTarget.location_id"
                        [(ngModel)]="performanceTarget.amount"
                        (input)="targetAmountChanged(performanceTarget)"
                    />
                </div>
                <label class="col-3">
                    <input
                    class="input--small"
                    type="number"
                    [name]="'target-good' + performanceTarget.location_id"
                    required
                    [(ngModel)]="performanceTarget.good_target"
                    />                   
                </label>
                <label class="col-3">
                    <input
                    class="input--small"
                    type="number"
                    [name]="'target-great' + performanceTarget.location_id"
                    required
                    [(ngModel)]="performanceTarget.great_target"
                    /> 
                </label>
            </div>

            <label class="input-error" *ngIf="form.submitted"
                >Please enter all required fields.</label
            >
        </div>

        <loader *ngSwitchDefault></loader>

        <div class="btns btns--horizontal" mat-dialog-actions>
            <button type="button" class="btn" (click)="changeStep(0)">
                Cancel
            </button>
            <input
                class="btn btn--primary"
                type="submit"
                value="Save"
                *ngSwitchCase="true"
            />
        </div>
    </form>
</ng-container>
